<template>
    <div class="site-main mt20">
    	<div class="said-wrap">
    		<said :items="events" @setData="setData" class="b-shadow mb20"></said>
    		<infinite-loading @infinite="onInfinite" ref="infiniteLoading" v-show="control == false">
	      		<span slot="no-more">我是有底线的</span>
    		</infinite-loading>
    		<div class="more-btn" @click="loadMore" v-show="control == true">
	    		<img src="../common/images/more-icon.png" alt="加载更多">
	    	</div>
    	</div>
    	<div class="dialog" id="inner">
        	<div class="mask" @click="close_dialog"></div>
	        <div class="dialogBox">
	          <div class="modal-hd">
	            <img src="../common/images/shareBG-hd.jpg" alt="">
	            <div class="info"><span class="addr">深圳</span><span class="date">{{formateTime(shareDate.published_time)}}</span></div>
	          </div>
	          <div class="modal-bd">
	            <div class="tit">{{shareDate.post_title}}</div>
	            <div class="text-content">{{shareDate.post_excerpt}}</div>
	          </div>
	          <div class="modal-btm">
	            <img src="../common/images/shareBG-btm.jpg" alt="">
	          </div>
	        </div>
        	<div class="loading"><img src="../common/images/loading.gif" alt="加载中。。。"></div>
        	<div class="imgBox" id="pic"></div>
    	</div>
    </div>
</template>

<script>
import said from '../components/said.vue';
import {httpHead,apiUrl,setSEO} from '../common/util/config.js';
import InfiniteLoading from 'vue-infinite-loading'
import $ from 'jquery'
export default {
    data () {
        return {
        	events: [],
        	page: 0,
        	totalPage: 0,
        	shareDate: {},
        	control:false,
        	cid:1,
        	pageSeo:{}
        }
    },
    created () {
    	let postData = this.$qs.stringify({
			'cid': this.cid
		});
		let url = apiUrl+'api/lists'
		this.$axios({
			method: 'post',
		    url: url,
		    headers: httpHead,
		    data:postData
    	})
    		.then(res => {
                this.pageSeo = res.data.data.seo;
                setSEO(this.pageSeo);
            })
            .catch(err => {
                if (err.response) {
                    console.log(err.response)
                }
            })
    },
    methods: {
    	onInfinite ($state) {
    		let postData = this.$qs.stringify({
			    cid: this.cid
			});
			this.page++;
			let url = apiUrl+'api/lists/page/'+this.page
    		this.$axios({
    			method: 'post',
			    url: url,
			    headers: httpHead,
			    data:postData
    		})
	        	.then(res => {
	        		this.totalPage = res.data.data.list.last_page;
	                this.events = this.events.concat(res.data.data.list.data);
	                if(this.page > 2){
	                	this.control = true;
	                }
	                if(this.control == false){
	                	$state.loaded();
	                }
	                
	                if(this.totalPage == this.page){
	                	$state.complete();
	                }
	            })
	            .catch(err => {
	                if (err.response) {
	                    console.log(err.response)
	                    $state.complete()
	                }
	            })
	    },
	    formateTime (date) {
    		let time = new Date(date*1000);
    		let fmt = 'yy-mm-dd'
    		if(/(y+)/.test(fmt)){
    			let year = time.getFullYear(); 
    			fmt = fmt.replace(RegExp.$1,year);
    		}
    		if(/(m+)/.test(fmt)){
    			let month = time.getMonth() + 1;
    			month = month < 10 ? '0' + month : month;
    			fmt = fmt.replace(RegExp.$1,month);
    		}
    		if(/(d+)/.test(fmt)){
    			let day = time.getDate();
    			day = day < 10 ? '0' + day : day;
    			fmt = fmt.replace(RegExp.$1,day);
    		}
    		return fmt;
    	},
    	makePic () {
            var w = $('.dialogBox').width();
            var h = $('.dialogBox').height();
            var canvas = document.createElement("canvas");
            var dpi = window.devicePixelRatio;
            canvas.width = w * dpi;
            canvas.height = h * dpi;
            canvas.style.width = w + "px";
            canvas.style.height = h + "px";
            var context = canvas.getContext("2d");//然后将画布缩放，将图像放大两倍画到画布上
            context.mozImageSmoothingEnabled = false;
            context.webkitImageSmoothingEnabled = false;
            context.msImageSmoothingEnabled = false;
            context.imageSmoothingEnabled = false;

             context.scale(dpi,dpi);
             // console.log(context)
			 //console.log('dpi:'+window.devicePixelRatio);
            html2canvas($("#inner .dialogBox"), {
                allowTaint: true,
                taintTest: false,
				useCROS:true,
                canvas: canvas,
                onrendered: function(canvas) {
                    var img = new Image();
                    img.src = canvas.toDataURL();
                    img.setAttribute('download','share.png');
                    $("#pic").html(img);
                    setTimeout(function(){
                      $(".dialog .loading").hide();
                      $(".dialog .imgBox").fadeIn(100);
                    },1000)
                }
            });
        },
        setData (value) {
	    	this.shareDate = value;
	    	$(".dialog").show();
	    	$(".dialog .loading").show();
            $(".dialog .imgBox").hide();
	    	setTimeout(() => {
	    		this.makePic();
	    	},500)
	    	
	    },
	    close_dialog () {
	    	$(".dialog").fadeOut(100);
	    },
	    loadMore () {
	    	this.control = false;
	    	this.$nextTick(() => {
		        this.$refs.infiniteLoading.attemptLoad();
		    });
	    }
    },
    components: {
    	said,
    	InfiniteLoading
    }
}
</script>

<style lang="scss">
.dialog{
	position: fixed;
	top:0;
	left:0;
	right:0;
	bottom: 0;
	z-index: 999;
	display: none;
	.mask{
		position: absolute;
		left:0;
		top:0;
		width: 100%;
		height: 100%;
		background:rgba(0,0,0,0.6);
		z-index: 99;
	}
	.imgBox{
		display: block;
		position: absolute;
		z-index: 111;
		text-align: center;
		width: 80%;
		max-height: 90%;
		top: 50%;left: 50%; transform: translate(-50%,-50%);
		img{
			max-width:100%;
			max-height:100%;
		}
	}
	.loading{
		position: absolute;
		z-index: 122;
		top: 50%;
		left: 0;
		width: 100%;
		text-align: center;
		transform: translateY(-50%);
		img{
			width: 2rem
		}
	} 
}
.dialogBox{
	position: absolute;
	z-index:-1;
	opacity: 0;
	.modal-hd{
		position: relative;
		img{
			width: 100%;
		}
		.info{
			position: absolute;
			bottom: .2rem;
			right: 0;
			text-align: right;
			padding-right: .2rem;
			color: #fff;
			font-size: .26rem;
			span{
				margin-left:.1rem;
			}
		} 
	}
	.modal-btm{
		margin-top: -1px;position: relative;
		img{
			width: 100%;
		}
	}
	.modal-bd{
		height: auto;
		padding:.5rem .45rem;
		background:url("../common/images/shareBG-bd.jpg") 0 repeat-y;
		background-size:100%;
		min-height:5rem;
		position: relative;
		.tit{
			margin:0 auto .2rem;
			font-size:20px;
			line-height: 1.3;
			color: #033187;
			text-align:left;
		}
		.text-content{
			line-height: 1.5;
			font-size: 14px;
			color: #333;
			text-indent: .4rem;
		}
	}

}
</style>


// WEBPACK FOOTER //
// src/page/bigView.vue